export default () => {
    // Get the navbar wrapper element
    const navbarWrapper = document.querySelector('.navbar-wrapper')
    const breakpointXl = 1200

    // If there's no navbarWrapper, return
    if (!navbarWrapper)
        return

    // Attrs/identifiers
    const drodopwnExpandedAttr = 'data-dropdown-expanded'
    const drodopwnItemAttr = 'data-dropdown-item'

    // Get toggler
    const navbarMobile = navbarWrapper.querySelector('.navbar-main')

    // Get items that has submenu
    const menuChildrenBtns = Array.from(navbarWrapper
        .querySelectorAll('button.menu-item-wrapper-cta'))

    const menuOpenCss = 'menu-item-open'

    // Search overlay
    const searchOverlay = document.getElementById('overlay-search')

    const listen = () => {
        navbarWrapper
            .addEventListener('click', (e) => {
                if (window.innerWidth >= breakpointXl) {
                    const menuItem = e.target
                        .closest('.menu-item')
                    const menuSubItem = e.target
                        .closest('.menu-item-sub-content')

                    if (!menuItem
                            && !menuSubItem)
                        dropdownCloseAll()
                }
            })

        menuChildrenBtns
            .forEach(btn => btn
                .addEventListener('click', dropdownToggle))

        if (navbarMobile) {
            const toggleClass = () => {
                navbarWrapper.classList.toggle('navbar-wrapper-open')
            }

            navbarMobile
                .addEventListener('show.bs.offcanvas', toggleClass)

            navbarMobile
                .addEventListener('hide.bs.offcanvas', () => {
                    toggleClass()
                    dropdownCloseAll()
                })
        }

        if (searchOverlay)
            searchOverlay
                .addEventListener('shown.bs.modal', () => {
                    if (document.activeElement !== searchOverlay)
                        return

                    const input = searchOverlay
                        .querySelector('input[type=search]')

                    if (input)
                        input.focus()
                })

        window.addEventListener('resize', (e) => {
            if (window.innerWidth < breakpointXl
                    && navbarWrapper.getAttribute(drodopwnExpandedAttr)
                        === 'true')
                dropdownCloseAll()
        })
    }

    const dropdownToggle = (e) => {
        if (e.type.match(/mouse/)
                && window.innerWidth < breakpointXl)
            return

        const el = e.target
            .closest('.menu-item')

        const show = !el.classList.contains(menuOpenCss)
            && e.type !== 'mouseleave'

        const overflowHidden = show
                || navbarWrapper.classList.contains('navbar-wrapper-open')
            ? 'hidden'
            : ''

        el.setAttribute('data-dropdown-expanding', show)

        navbarWrapper
            .setAttribute(drodopwnItemAttr, 0)

        if (show)
            dropdownCloseAll()

        document.body
            .style.overflow = overflowHidden

        el.classList[show
            ? 'add'
            : 'remove'
        ](menuOpenCss)

        el.querySelector('a, button')
            ?.setAttribute('aria-expanded', show)

        navbarWrapper
            .setAttribute(drodopwnExpandedAttr, show)

        if (show)
            navbarWrapper
                .setAttribute(drodopwnItemAttr, el.dataset.menuItem)

        setTimeout(() => el
            .removeAttribute('data-dropdown-expanding'), 400)
    }

    const dropdownCloseAll = (e) => {
        if (((e || {}).type || '').match(/mouse/)
                && (window.innerWidth < breakpointXl
                    || (e.relatedTarget.parentElement.contains(e.target)
                        && e.relatedTarget.parentElement.classList
                            .contains('menu-item'))))
            return

        const els = navbarWrapper.querySelectorAll(`.${menuOpenCss}`)

        if (!els)
            return

        els.forEach(el => {
            el.querySelector('a, button')
                ?.setAttribute('aria-expanded', false)

            el.classList.remove(menuOpenCss)
        })

        navbarWrapper
            .setAttribute(drodopwnExpandedAttr, false)

        navbarWrapper
            .setAttribute(drodopwnItemAttr, 0)

        document.body.style.overflow = ''
    }

    listen()
}
